import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/company/empty.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-38f793ff"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "table-empty"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

var _hoisted_3 = {
  class: "text"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    emptyText: String
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(__props.emptyText), 1)]);
    };
  }
});